import { createApp } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import { Drawer as TDrawer } from 'tdesign-vue-next';
import App from '~/pages/App.vue';
import Index from '~/pages/Index.vue';
import Detail from '~/pages/Detail.vue';
import Feedback from '~/pages/Feedback.vue';
import MyList from '~/pages/MyList.vue';
import MyDetail from '~/pages/MyDetail.vue';
import store from '~/store/index.js';
import '@tencent/rem';
import './index.scss';
import 'tdesign-vue-next/es/style/index.css';

const routes = [
  { path: '/index', component: Index, alias: '/index/pid', meta: { title: '问题与反馈' } },
  { path: '/index/pid/:productId?', component: Index, meta: { title: '问题与反馈' } },
  { path: '/detail', component: Detail, meta: { title: '问题与反馈' } },
  { path: '/feedback/:productId?', component: Feedback, meta: { title: '我要反馈' } },
  { path: '/myList', component: MyList, meta: { title: '反馈进度' } },
  { path: '/myDetail', component: MyDetail, meta: { title: '反馈进度' } },
];

const router = createRouter({
  history: createWebHashHistory('/#!'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

createApp(App).use(router)
  .use(store)
  .use(TDrawer)
  .mount('#app');
